

/**
 * UpdateEquipamentoMedicoesUseCase
 */

import { uploadFileToBase64String } from "../../../../../common/utils/utils";
import { IUpdateEquipamentoMedicoesUseCase } from "../../../presentation/useCases/update/update_equipamento_medicoes_use_case";
import { IEquipamentoMedicaoRepository } from "../../repositories/EquipamentoMedicao_Repositorie";

export class UpdateEquipamentoMedicoesUseCase implements IUpdateEquipamentoMedicoesUseCase {
  constructor(private readonly repository: IEquipamentoMedicaoRepository) { }

  async updateEquipamentoMedicao(
    idEquipamentoMedicao?: number,
    idObra?: number | null,
    equipamento?: string,
    idFuncionario?: number,
    idFuncionarioMonit?: number,
    descResponsavelMonit?: string,
    responsavelCadastradoMonit?: string,
    frequenciaVerificao?: number,
    idFuncionarioResp?: number,
    descResponsavelResp?: string,
    responsavelCadastradoResp?: boolean,
    dataVerificacao?: Date,
    dataProxVerificacao?: Date,
    tipoMonitoramento?: string,
    arquivo?: File | null,
    nomeArquivo?: string,
    arquivo1?: File | null,
    nomeArquivo1?: string,
    observacao?: string,
    idCentroCusto?: number,
    idFornecedorMonit?: number,
    tipoVerificacao?: boolean,
    tipoRespEquipamento?: number,
    tipoCaliVeriiPor?: number,
    tipoFrequenciaData?: number,

    limparArquivo?: boolean,
    limparArquivo1?: boolean

  ): Promise<void> {
    await this.repository.updateEquipamentoMedicao(
      idEquipamentoMedicao,
      idObra,
      equipamento,
      idFuncionario,
      idFuncionarioMonit,
      descResponsavelMonit,
      responsavelCadastradoMonit,
      frequenciaVerificao,
      idFuncionarioResp,
      descResponsavelResp,
      responsavelCadastradoResp,
      dataVerificacao,
      dataProxVerificacao,
      tipoMonitoramento,
      arquivo ? await uploadFileToBase64String(arquivo) : undefined,
      nomeArquivo,
      arquivo1 ? await uploadFileToBase64String(arquivo1) : undefined,
      nomeArquivo1,
      observacao,
      idCentroCusto,
      idFornecedorMonit,
      tipoVerificacao,
      tipoRespEquipamento,
      tipoCaliVeriiPor,
      tipoFrequenciaData,
      limparArquivo,
      limparArquivo1

    );

  }
}
